import { IInitialState } from 'store/models';
import { moduleStateSelector } from './moduleStateSelector';

export function moduleProgressSelector(state: IInitialState) {
	return moduleStateSelector(state).moduleProgress;
}
